import { EnvironmentProvisioningState } from '../../constants/environment';
import { Environment, FailureOnEnvironment } from '../../models/environment';
import { createStringIdAdapter } from './common/string-id-adapter';

export const environmentAdapter = createStringIdAdapter<Environment>();
export const environmentProvisioningStateAdapter = createStringIdAdapter<EnvironmentProvisioningState>();
export const failureOnEnvironmentAdapter = createStringIdAdapter<FailureOnEnvironment>();
